import { shortlistsApiSingleton } from 'v4/migration/shortlistsApiSingleton';
import { createShortlistsHooks } from './shortlist.hooks';

export const myShortlists = createShortlistsHooks(shortlistsApiSingleton);
